import React ,{useEffect,useState} from 'react';

import './App.css';

import {HashRouter as Router, Switch, Route, Link,withRouter} from 'react-router-dom'
import 'bootstrap/dist/css/bootstrap.css';


import Home from './pages/Home'
import Patients from "./pages/Patients";
import EditPatient from "./pages/editPatient";
import Login from "./login/login";
import {AuthProvider } from "./login/Auth";
import PrivateRoute from "./login/PrivateRoute";
import SignUp from "./login/SignUp";
import NewPatientPage from "./pages/newPatient";
import NewVisit from "./pages/newVisit";
import Account from "./pages/account";
import viewDemographics from "./pages/viewDemographics"
import ErrorPage from "./pages/ErrorPage"
import AuditTrailDashboard from "./pages/AuditTrail";
import ViewPatient from './components/ViewPatient';
import Admin from "./pages/admin/admin"
import axios from 'axios';
class  App extends React.Component{
  constructor(props){
    super(props)
    this.state ={}
    // var link ;
    // axios.get('settings.json').then((res)=>{
    //     link = res.data.configuration // getting conf link from settings
    // }).then( async ()=>{
    //     await axios.get(process.env.REACT_APP_configuration).then(async (res)=>{
    //       var data = res.data;
    //       this.setState(data)
        
            
            
    //     })
    //   })
    this.getConf();
   
    
  }
  async getConf(){
    await axios.get(process.env.REACT_APP_configuration).then(async (res)=>{
      var data = res.data;
      this.setState(data)
    
        
        
    })
  }
  
  // const [conf,setConf] = useState({})
  // const [mounted,setMounted] = useState(false)

//   useEffect( ()=>{
//     setMounted(true)
//  },[])
  // );
  render(){
    
    return(
      <Router>
      <AuthProvider>
          
             <Switch>


              <Route path="/login">
             {this.state.allow_register =="1" ? <Login warning={this.state.show_development_warning ==='1'} loginMessage={this.state.loginMessage} /> : <Login disableRegister warning={this.state.show_development_warning =='1'} loginMessage={this.state.loginMessage} />}
              </Route>
              {this.state.allow_register == "1" && <Route path="/signup" component={SignUp}/>}
              <PrivateRoute  exact={true} path = {`/`}  component={Home} />
              <PrivateRoute  exact={true} path={`/patients`}  component={Patients}/>
              <PrivateRoute  exact={true} path={`/editPatient/:id`}  component={EditPatient}/>
              <PrivateRoute  exact={true} path={"/newPatient"} component={NewPatientPage}/>
              <PrivateRoute  exact={true} path={"/editPatient/:id/new/:visitNo"} component={NewVisit}/>
              <PrivateRoute exact={true} path={"/settings"} component={Account}/>
              <PrivateRoute exact={true} path={"/editPatient/:id/demographics"} component={viewDemographics}/>
                 <PrivateRoute exact={true} path={"/auditTrail"} component={AuditTrailDashboard}/>
              <Route exact path="*" component={ErrorPage} />
            

  
            </Switch>
          
        </AuthProvider>
      </Router>


    )
  }
}

export default App;
